import { defineMessage } from 'services/localization';

export const messages = {
    additionalOptionsTitle: defineMessage('additional_options'),
    editButtonTitle: defineMessage('edit'),
    useLinesMergeCheckboxTitle: defineMessage('dont_extract_line_items'),
    useLinesMergeCheckboxDescription: defineMessage('approvalmax_capture_wil_nto_a_single_total_line'),
};
